// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataDonutChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3.62a.524.524 0 0 1-.437.509A8.002 8.002 0 0 0 4.47 14.704a.523.523 0 0 1-.222.633l-.883.51a.48.48 0 0 1-.691-.233A9.976 9.976 0 0 1 2 12c0-4.996 3.664-9.137 8.452-9.88A.48.48 0 0 1 11 2.6zM19.758 15.324a.523.523 0 0 1-.222-.632 8.002 8.002 0 0 0-6.099-10.564A.524.524 0 0 1 13 3.62V2.601a.48.48 0 0 1 .548-.482C18.336 2.863 22 7.004 22 12c0 1.27-.236 2.483-.668 3.6a.48.48 0 0 1-.691.234zM19.639 17.565a.48.48 0 0 1 .143.716A9.98 9.98 0 0 1 12 22a9.98 9.98 0 0 1-7.773-3.708.48.48 0 0 1 .143-.717l.883-.51a.523.523 0 0 1 .657.123A7.982 7.982 0 0 0 12 20a7.982 7.982 0 0 0 6.099-2.822.523.523 0 0 1 .657-.123z"
    />
  </svg>
);
export default SvgDataDonutChart;
